/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { getBranchesList } from "../../../../apis/companies/branches";
import HeadBranch from "./HeadBranch";
import HeadBranchTable from "./HeadBranchTable";

const HEAD_BRANCH_TYPE = [
  { title: '요청내역', type: 9 },
  { title: '본점정보', type: 1 },
  { title: '지점정보', type: 0 },
]

const HeadBranchList = ({ permission }) => {
  const [open, setOpen] = useState(false)
  const [type, setType] = useState(0)

  return (
    <div className="HeadBranch">
      {HEAD_BRANCH_TYPE.map((headBranch, idx) => (
        <HeadBranchTable
          key={idx}
          title={headBranch.title}
          tableType={headBranch.type}
          setOpen={setOpen}
          setType={setType}
          api={getBranchesList}
          permission={permission}
        />
      ))}
      <HeadBranch open={open} setOpen={setOpen} type={type} />
    </div>
  );
};

export default HeadBranchList;
